import React from 'react';
import {View} from 'react-native';
import {
  SafeAreaConsumer,
  SafeAreaProvider as ReactNativeSafeAreaProvider,
} from 'react-native-safe-area-context';

import {styles} from './SafeAreaProvider.style';

interface SafeAreaProviderProps {
  children: React.ReactNode;
}

export class SafeAreaProvider extends React.PureComponent<SafeAreaProviderProps> {
  static defaultProps = {
    children: null,
  };

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {children} = this.props;

    return (
      <ReactNativeSafeAreaProvider>
        <SafeAreaConsumer>
          {insetsProps => {
            const insetStyle = {
              paddingTop: 0,
              paddingBottom: 0,
              // @ts-expect-error TS(2531): Object is possibly 'null'.
              paddingLeft: insetsProps.left,
              // @ts-expect-error TS(2531): Object is possibly 'null'.
              paddingRight: insetsProps.right,
            };

            return <View style={[styles.base, insetStyle]}>{children}</View>;
          }}
        </SafeAreaConsumer>
      </ReactNativeSafeAreaProvider>
    );
  }
}

export default SafeAreaProvider;
